import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const USER = 'user'
export const ADMIN = 'admin'
export const CHANGE = 'change'

export default {
  [PORTUGUESE]: {
    [USER]: 'Usuário',
    [ADMIN]: 'Administrador',
    [CHANGE]: 'Mudar',
  },

  [ENGLISH]: {
    [USER]: 'User',
    [ADMIN]: 'Admin',
    [CHANGE]: 'Change',
  },

  [SPANISH]: {
    [USER]: 'Usuario',
    [ADMIN]: 'Administrador',
    [CHANGE]: 'Cambiar',
  },
}
